<template>
        <span>
                <el-button type="text" icon="el-icon-view" @click="openDialog" >查看</el-button>
                <el-dialog
                        title="查看"
                        width="65%"
                        
                        :bottom="0"
                        append-to-body
                        v-if="dialogVisible"
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        查看
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow:scroll;">
                <el-form ref="form" :model="form" label-width="80px">
                <el-row>
                        <el-col span="8" v-for="item in columnSlot" :key="item.prop">
                                <el-form-item :label="item.label">
                                        <el-input v-model="form[item.prop]" :disabled="true"></el-input>
                                </el-form-item>
                        </el-col>
                </el-row>
                <el-row>
                        <el-col span="8" >
                                <el-form-item label="任务明细">
                                        
                                </el-form-item>
                        </el-col>
                </el-row>
                </el-form>
                <avue-crud 
                        v-if="type ==1 ||type==2"
                        :data="data" 
                        :option="option"
                        ref="crud"
                   
                        >
                        <template slot-scope="scope" slot="status">
                                <div style="line-height: 0px;">
                                        {{(scope.row.inspectFlag==1||scope.row.upkeepFlag==1)? "完成" : ""}}
                                </div>
                                
                        </template>
                        <template slot="menu" slot-scope="scope">
                                <el-button type="text" icon="el-icon-view" @click="openDetailsDialog(scope.row)" >详情</el-button>
                                
                        </template>
                        <template slot-scope="scope" slot="deviceName">
                                                      <span>{{scope.row.deviceName}}</span><span v-if="scope.row.assetStatus==2" style="color:red"> (报废)</span>
                        </template>

                </avue-crud>
                <avue-crud 
                 v-else
                        :data="data" 
                        :option="comprehensiveOption"
                        ref="crud"
                   
                        >
                        <template slot-scope="scope" slot="status">
                                <div style="line-height: 0px;">
                                        {{(scope.row.inspectFlag==1||scope.row.upkeepFlag==1)? "完成" : ""}}
                                </div>
                                
                        </template>
                        <template slot="menu" slot-scope="scope">
                                <el-button type="text" icon="el-icon-view" @click="openDetailsDialog(scope.row)" >详情</el-button>
                                
                        </template>
                        <template slot-scope="scope" slot="deviceName">
                                                      <span>{{scope.row.deviceName}}</span><span v-if="scope.row.assetStatus==2" style="color:red"> (报废)</span>
                        </template>

                </avue-crud>
                
                <detailForm  ref="detailForm"  :form="form" :projectList.sync="projectList"></detailForm>
                </div>
                </el-dialog>
        </span>
</template>

<script>
import {getTaskDetail,getProjectList} from "@/api/crmedical/device/taskManagement";
import addInspectionRecord2 from "@/components/device/deviceInspectionRecord/deviceInspect.vue"
import detailForm from "./details.vue"
export default {
        components:{detailForm,addInspectionRecord2},
        props:{
                id:{
                        type:String,
                        default:"",
                }
        },
        data(){
                return{
                        detailRow:{},
                        addOrEditFlag:false,
                        operatorModel:'view',
                        projectList:[],
                        columnSlot:[],
                        loading:false,
                        dialogFull:false,
                        dialogVisible:false,
                        data:[],
                        form:{},
                        type:1,
                        option:{
                                tip: false,
                                maxHeight:400,
                                cellBtn:false,
                                addBtn:false,
                                header:false,
                                refreshBtn:false,
                                searchBtn:false,
                                searchShowBtn:false,
                                selection:false,
                                selectClearBtn:false,
                                columnBtn:false,
                                index:true,
                                menuBtn:false,
                                editBtn:false,
                                delBtn:false,
                                emptyBtn:false,
                                indexLabel:"序号",
                                column:[
                                        {
                                                label: '项目名称',
                                                prop: 'projectId',
                                                searchSlot:true,
                                                typeslot: true,
                                                slot:true,
                                                searchDisabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '任务类型',
                                                prop: 'type',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划人员',
                                                prop: 'executeUserId',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '任务名称',
                                                prop: 'name',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '开始时间',
                                                prop: 'validStartTime',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '结束时间',
                                                prop: 'validEndTime',
                                                searchSlot:true,
                                                searchDisabled:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '标准名称',
                                                prop: 'standardName',
                                                searchSlot:true,
                                                searchDisabled:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '设备名称',
                                                prop: 'deviceName',
                                                slot:true
                                        },
                                        {
                                                label: '设备类型',
                                                prop: 'deviceType',
                                        },
                                        {
                                                label: '设备编号',
                                                prop: 'code',
                                        },
                                        

                                        {
                                                label: '所属部门',
                                                prop: 'deptName',
                                        },
                                        {
                                                label: '存放位置',
                                                prop: 'areaName',
                                        },
                                        {
                                                label: '执行时间',
                                                prop: 'realInspectTime',
                                        },
                                        {
                                                label: '执行人员',
                                                prop: 'realInspectManName',

                                        },
                                        {
                                                label: '执行时间',
                                                prop: 'realUpkeepTime',
                                        },
                                        {
                                                label: '执行人员',
                                                prop: 'realUpkeepManName',
                                        },
                                        
                                        {
                                                label: '任务结果',
                                                prop: 'status',
                                                slot:true,
                                        },
                                ]
                        },
                         comprehensiveOption:{
                                tip: false,
                                maxHeight:400,
                                cellBtn:false,
                                addBtn:false,
                                header:false,
                                refreshBtn:false,
                                searchBtn:false,
                                searchShowBtn:false,
                                selection:false,
                                selectClearBtn:false,
                                columnBtn:false,
                                index:true,
                                menuBtn:false,
                                editBtn:false,
                                delBtn:false,
                                emptyBtn:false,
                                indexLabel:"序号",
                                column:[
                                        {
                                                label: '项目名称',
                                                prop: 'projectId',
                                                searchSlot:true,
                                                typeslot: true,
                                                slot:true,
                                                searchDisabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '任务类型',
                                                prop: 'type',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '计划人员',
                                                prop: 'executeUserId',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '任务名称',
                                                prop: 'name',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '开始时间',
                                                prop: 'validStartTime',
                                                searchSlot:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '结束时间',
                                                prop: 'validEndTime',
                                                searchSlot:true,
                                                searchDisabled:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                         {
                                                label: '标准名称',
                                                prop: 'standardName',
                                                searchSlot:true,
                                                searchDisabled:true,
                                                disabled:true,
                                                searchSpan:8,
                                                search:false,
                                                hide:true,
                                        },
                                        {
                                                label: '区域编号',
                                                prop: 'code',
                                        },
                                        {
                                                label: '区域名称',
                                                prop: 'areaName',
                                                
                                        },
                                        
                                         {
                                                label: '区域全称',
                                                prop: 'fullName',
                                        },
                                        

                                        {
                                                label: '所属部门',
                                                prop: 'deptName',
                                        },
                                        
                                        {
                                                label: '执行时间',
                                                prop: 'realInspectTime',
                                        },
                                        {
                                                label: '执行人员',
                                                prop: 'realInspectManName',

                                        },
                                        {
                                                label: '执行时间',
                                                prop: 'realUpkeepTime',
                                        },
                                        {
                                                label: '执行人员',
                                                prop: 'realUpkeepManName',
                                        },
                                        
                                        {
                                                label: '任务结果',
                                                prop: 'status',
                                                slot:true,
                                        },
                                ]
                        }
                }
        },
        methods:{
                // 打开自己弹窗
                openDialog(row){
                        let realInspectTime = this.findObject(this.option.column,'realInspectTime');
                        let realUpkeepTime = this.findObject(this.option.column,'realUpkeepTime');
                        let realInspectManName = this.findObject(this.option.column,'realInspectManName');
                        let realUpkeepManName = this.findObject(this.option.column,'realUpkeepManName');
                         let realInspectTime_ = this.findObject(this.comprehensiveOption.column,'realInspectTime');
                        let realUpkeepTime_ = this.findObject(this.comprehensiveOption.column,'realUpkeepTime');
                        let realInspectManName_ = this.findObject(this.comprehensiveOption.column,'realInspectManName');
                        let realUpkeepManName_ = this.findObject(this.comprehensiveOption.column,'realUpkeepManName');
                        if(row.type==1){
                                realInspectTime.hide = false;
                                realUpkeepTime.hide = true;
                                realInspectManName.hide = false;
                                realUpkeepManName.hide = true;
                        }else if(row.type==2){
                                realInspectTime.hide = true;
                                realUpkeepTime.hide = false;
                                realInspectManName.hide = true;
                                realUpkeepManName.hide = false;
                        }else if(row.type==3){
                               realInspectTime_.hide = false;
                                realUpkeepTime_.hide = true;
                                realInspectManName_.hide = false;
                                realUpkeepManName_.hide = true;
                               
                        }
                        this.form.projectId = row.$projectId;
                        this.projectId = row.projectId;
                        this.form.type = row.$type;
                        this.type = row.type;
                        this.form.executeUserId = row.executeUserName;
                        this.form.name = row.name;
                        this.form.validStartTime = row.validStartTime;
                        this.form.validEndTime = row.validEndTime;

                        this.dialogVisible = true;
                        this.initData(row.id);
                },
                // 打开详情弹窗
                openDetailsDialog(row){
                        this.detailRow = row
                        // this.addOrEditFlag =true
                        
                        // this.
                        this.$refs.detailForm.openDialog(row,this.type,this.projectId);
                },
                // 初始化数据
                async initData(id){
                        this.loading = true;
                        let columnSlot = [];
                        this.option.column.forEach(ele=>{
                                if(ele.searchSlot){
                                        columnSlot.push(ele);
                                }
                        })
                        this.columnSlot = columnSlot;
                        await getTaskDetail({id:id}).then(res=>{
                                this.loading = false;

                                this.data = res.data.taskList;
                                this.form.standardName = res.data.standardName

                        }).catch(err=>{
                                this.loading = false;
                        })

                        await getProjectList().then(res=>{
                                this.projectList = res.data;
                        })
                        console.log(this.columnSlot)
                }
        }
}
</script>